<template lang="html">
  <div class="progress-bar">
    <div
      :style="{width: progressWidth, background: color}"
      :class="progressClass"
    />
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',

  props: {
    progress: { type: Number, required: true },
    duration: { type: Number, required: true },
    color: { type: String, default: null }
  },

  data () {
    return {
      reset: false
    }
  },

  computed: {
    progressClass  () {
      return {
        'progress-value': true,
        reset: this.reset
      }
    },

    progressWidth () {
      return this.duration !== 0 ? `${this.progress / this.duration * 100}%` : '0%'
    }
  },

  watch: {
    progress (newVal, oldVal) {
      this.reset = oldVal > newVal
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/styles/colors";

.progress-bar{
  background: #d8d8d8;
  width: 100%;
  height: 10px;
  text-align: left;
  line-height: 0;
  font-size: 0;
  position: relative;
  border-radius: 5px;

  .progress-value{
    border-radius: 5px;
    position: relative;
    display: inline-block;
    height: 100%;
    transition: width 150ms;
    line-height: 0;
    background: $grey_cold_6;

    &.reset{
      transition: none !important;
    }
  }
}
</style>
